import Vue from 'vue'
import Router from 'vue-router'
import hello from '@/components/hello'
import product from '@/components/product'
import about from '@/components/about'
import cases from '@/components/case'
import programme from '@/components/programme'
import news from '@/components/news'
import newDetail from '@/components/newDetail'
import newDetails from '@/components/newDetails'
import proDetails from '@/components/proDetails'
import proDetail from '@/components/proDetail'
import increment from '@/components/increment'
import apps from '@/components/app'
import wangzhan from '@/components/wangzhan'
import weixin from '@/components/weixin'
import htmls from '@/components/htmls'
import sheji from '@/components/sheji'
import moban from '@/components/moban'
import lianxi from '@/components/lianxi'
import wenhua from '@/components/wenhua'
import huanjing from '@/components/huanjing'
import jiaru from '@/components/jiaru'
import jianjie from '@/components/Companyprofile'
import development from '@/components/course'
import sysj from '@/components/sysj'
import help from '@/components/help_content'
Vue.use(Router)

export default new Router({
  // scrollBehavior: () => ({y: 0}),//点击切换路由之后页面回到顶部
  routes: [
    {
      path: '/',
      name: 'hello',
      component: hello
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/case',
      name: 'case',
      component: cases
    },
    {
      path: '/programme',
      name: 'programme',
      component: programme
    },
    {
      path: '/about',
      name: 'chuxin',
      component: about
    },
    {
      path:'/Companyprofile',
      name:'gongsijianjie',
      component: jianjie
    },
    {
      path:'/course',
      name:'course1',
      component: development
    },
    {
      path: '/huanjing',
      name: 'bangonghuanjing',
      component: huanjing
    },
    {
      path: '/jiaru',
      name: 'jiaruwomen',
      component: jiaru
    },
    {
      path: '/news',
      name: 'news',
      component: news,
    },
    {
      path: '/newDetail',
      name: 'newDetail',
      component: newDetail
    },
    {
      path: '/newDetails',
      name: 'newDetails',
      component: newDetails
    },
    {
      path: '/proDetails',
      name: 'proDetails',
      component: proDetails
    },
    {
      path: '/proDetail',
      name: 'proDetail',
      component: proDetail
    },
    {
      path: '/sysj',
      name: 'sysj',
      component: sysj
    },
    {
      path: '/apps',
      name: 'apps',
      component: apps
    },
    {
      path: '/increment',
      name: 'increment',
      component: increment
    },
    {
      path: '/wangzhan',
      name: 'wangzhan',
      component: wangzhan
    },
    {
      path: '/weixin',
      name: 'weixin',
      component: weixin
    },
    {
      path: '/htmls',
      name: 'htmls',
      component: htmls
    },
    {
      path: '/sheiji',
      name: 'sheiji',
      component: sheji
    },
    {
      path: '/moban',
      name: 'moban',
      component: moban
    },
    {
      path: '/wenhua',
      name: 'wenhua',
      component: wenhua
    },
    {
      path: '/lianxi',
      name: 'lianxi',
      component: lianxi
    },
    {
      path: '/help_content',
      name: 'help',
      component: help
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js